module.exports = btoa
